import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CurrencyEuro = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 24C24.448 24 24 24.448 24 25C24 26.626 21.71 28 19 28C15.089 28 11.753 24.656 10.515 20H19C19.552 20 20 19.552 20 19C20 18.448 19.552 18 19 18H10.126C10.044 17.349 10 16.681 10 16C10 15.319 10.043 14.651 10.126 14H19C19.552 14 20 13.552 20 13C20 12.448 19.552 12 19 12H10.515C11.753 7.344 15.089 4 19 4C21.71 4 24 5.374 24 7C24 7.552 24.448 8 25 8C25.552 8 26 7.552 26 7C26 4.196 22.925 2 19 2C16.011 2 13.219 3.491 11.136 6.198C9.866 7.849 8.955 9.836 8.452 12H7C6.448 12 6 12.448 6 13C6 13.552 6.448 14 7 14H8.111C8.038 14.657 8 15.325 8 16C8 16.675 8.038 17.343 8.111 18H7C6.448 18 6 18.448 6 19C6 19.552 6.448 20 7 20H8.452C8.955 22.164 9.866 24.151 11.136 25.802C13.218 28.509 16.011 30 19 30C22.925 30 26 27.804 26 25C26 24.448 25.552 24 25 24Z" />
	</svg>
);

export default CurrencyEuro;
